import { render, staticRenderFns } from "./induction.vue?vue&type=template&id=3fb9faf0&scoped=true&"
import script from "./induction.vue?vue&type=script&lang=js&"
export * from "./induction.vue?vue&type=script&lang=js&"
import style0 from "./induction.vue?vue&type=style&index=0&id=3fb9faf0&lang=scss&scoped=true&"
import style1 from "./induction.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb9faf0",
  null
  
)

export default component.exports